import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon, EyeOffIcon, MailIcon } from 'lucide-react';
const ITEMS: Array<{
  icon: React.ReactNode;
  texto: string;
}> = [{
  icon: <LockIcon className="w-6 h-6" aria-hidden="true" data-id="element-283" data-mp="3fbo38ukhdloi" />,
  texto: 'Pago seguro'
}, {
  icon: <ShieldCheckIcon className="w-6 h-6" aria-hidden="true" data-id="element-284" data-mp="3f9jyybio6knp" />,
  texto: 'Garantía 14 días'
}, {
  icon: <ZapIcon className="w-6 h-6" aria-hidden="true" data-id="element-285" data-mp="3aagtipys2cf7" />,
  texto: 'Acceso inmediato'
}, {
  icon: <EyeOffIcon className="w-6 h-6" aria-hidden="true" data-id="element-286" data-mp="2mn8tonk4bvkk" />,
  texto: 'Tus datos, privados'
}, {
  icon: <MailIcon className="w-6 h-6" aria-hidden="true" data-id="element-287" data-mp="2in8bcrtwf088" />,
  texto: 'Soporte por mail'
}];
export function TrustBar() {
  return <section className="bg-crema-alt py-10 px-5" aria-label="Garantías de compra" data-id="element-288" data-mp="2rm276fzenmkq">
      <ul className="max-w-5xl mx-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 text-center" data-id="element-289" data-mp="2rjz8z8o3mn4x">
        {ITEMS.map(item => <li key={item.texto} className="flex flex-col items-center gap-2" data-id="element-290" data-mp="1yy6bnelko0pj">
            <span className="text-dorado" data-id="element-291" data-mp="2rrj0r8epe92v">{item.icon}</span>
            <span className="text-sm text-tinta/75" data-id="element-292" data-mp="2rr95p6esxbqb">{item.texto}</span>
          </li>)}
      </ul>
    </section>;
}